// extracted by mini-css-extract-plugin
module.exports = {"block":"Menu_block__3JbPV"};